import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Allitems } from "./utilNav";
import { checkPathNavFoot, instance } from "../../utils/utils";
import "./navBar.css";

const NavBar = ({ typeCustomer, handlePasswordUpdate }) => {
    const location = useLocation();
    const shouldHideNav = checkPathNavFoot(location.pathname, typeCustomer);
    const [plan, setPlan] = useState(null);
    const [companyInfo, setCompanyInfo] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!localStorage.my_code) return;
	    const [planResult, companyResult] = await Promise.allSettled([
     		 instance.get("/customers/company/plan/detail"),
	         instance.get("/memberships/corp/company")
	    ]);
	    if (planResult.status === "fulfilled") {
	        setPlan(planResult.value.data);
	    } else {
	        console.error("Error fetching plan:", planResult.reason);
	    }

	    if (companyResult.status === "fulfilled") {
	        setCompanyInfo(companyResult.value.data);
	    } else {
	        console.error("Error fetching company:", companyResult.reason);
	    }
        };
        fetchData();
    }, []);

    if (shouldHideNav) return null;

    return (
        <nav className="navbar-container d-flex align-items-center justify-content-start flex-column gap-5">
            <div className="navbar-logo-container">
                <svg className="mb-1" width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.1511 12.6924L9.63013 0.326172L0.11084 12.6924L0.0917969 12.72H5.38232L9.71997 25.6678L13.9854 12.72H19.1714L19.1511 12.6924Z" fill="white" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none">
                    <path d="M6.58459 0.628906H0.519531L1.47656 3.19604H5.62744L6.58459 0.628906Z" fill="#808FF3" />
                </svg>
            </div>
            <Allitems
                typeCustomer={typeCustomer}
                handlePasswordUpdate={handlePasswordUpdate}
                plan={plan}
                companyInfo={companyInfo}
            />
        </nav>
    );
};

export default NavBar;
